interface TextSegment {
  text: string;
  highlighted: boolean;
}

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function splitHeadwordOccurrences(text: string, headword: string): TextSegment[] {
  const target = headword.trim();
  if (!target) return [{ text, highlighted: false }];

  const matcher = new RegExp(`(?<![\\p{L}\\p{N}'’-])${escapeRegExp(target)}(?![\\p{L}\\p{N}'’-])`, "giu");
  const segments: TextSegment[] = [];
  let cursor = 0;
  for (const match of text.matchAll(matcher)) {
    const index = match.index;
    if (index > cursor) segments.push({ text: text.slice(cursor, index), highlighted: false });
    segments.push({ text: match[0], highlighted: true });
    cursor = index + match[0].length;
  }
  if (cursor < text.length) segments.push({ text: text.slice(cursor), highlighted: false });
  return segments.length ? segments : [{ text, highlighted: false }];
}

export function HighlightedHeadword({ text, headword }: { text: string; headword: string }) {
  return splitHeadwordOccurrences(text, headword).map((segment, index) => segment.highlighted
    ? <strong className="sentence-headword" key={index}>{segment.text}</strong>
    : segment.text);
}
